<style scoped>
#PreviousPage{
    width: 40px;
    height: 40px;
}
.list_img{
  width: 100%;
  height:100%;
}
.fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    background-color: #003567;
    border-radius: .25rem!important;
}
svg:hover{
    color:white !important;
}
path:hover{
    color:white !important;
}
</style>
<template>
    <div>
        <div class="container-fluid" style="padding:0px 5% 0px 5%;">
            <div class="row text-center">
                <div class="col-xl-12 col-lg-12 col-lg-12 col-md-12 text-left mt-5">
                    <h1 class="font-weight-bold news_title">{{!!news?news.title:''}}</h1>
                    <hr/>
                </div>
                <div class="col-xl-12 col-lg-12 col-lg-12 col-md-12 mt-5">
                    <slick
                        ref="slick"
                        :options="slickOptions"
                        style="margin:0px 20% 0px 20%"
                        v-if="!!news">
                        <div v-for="img in news.images" :key="img.id" >
                            <img :src="`${route}/${img.name}`" class="list_img" alt="">
                        </div>
                    </slick>
                </div>
                <div class="col-xl-12 col-lg-12 col-lg-12 col-md-12 mb-5 text-left content" style="font-size:20px;padding-top: 30px;" v-html="htmldecode_content"></div>
            </div>
        </div>
        <router-link to="/news">
            <div id="PreviousPage" class="fixed text-center">
                <span style="font-size: 25px; color: white;">
                    <font-awesome-icon :icon="['fas', 'arrow-left']"/>
                </span>
            </div>
        </router-link>
    </div>
</template>
<script>
export default {
    data(){
        return{
            news:null,
            route:null,
            slickOptions: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 2000,
                pauseOnHover: false,
            },
        }
    },
    mounted(){
        const id = this.$route.params.id;
        const self = this;
        this.$http.get(`https://www.kcsys.com.tw/kcsys/public/api/v1/news/${id}`)
        .then((response) => {
            self.news = response.data.data[0];
            self.route = response.data.route;
            if( self.news == undefined){
                self.$router.push({name:'news'})
            }
        })
    },
    methods:{
        htmldecode:function(s){
            const div = document.createElement('div');
            div.innerHTML = s;
            return div.innerText || div.textContent;
        },
    },
    computed:{
        htmldecode_content:function() {
            if(!!this.news){
                return this.htmldecode(this.news.content)
            }else{
                return ""
            }
            
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/newsBrowse.vue